import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SuperadminGuard implements CanActivate {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {

    }

    canActivate(): Observable<boolean> {
        // Refreshes an expired token first; logs out (with auth provider-specific redirects) only if that fails
        return this.authService.ensureAuthenticated().pipe(
            map(authenticated => authenticated && this.authService.getPrincipal().isSuperadmin)
        );
    }

}
